export default __webpack_public_path__ + "static/media/tutorial4-1.a75eeded.png";